import type { IconProps } from '../types/IconProps.ts';
export const LogOut: IconProps = {
    name: 'LogOut',
    children: [
        `<path d="M9 21H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h4M16 7l5.08 4.23a1 1 0 0 1 0 1.54L16 17M9 12h11" />`,
    ]
};